import { ChartTitle } from '../../pages/customerData/customerData';
import PieChartComponents from '../CustomerDataComponents/PieChartComponents';
import React, { useEffect, useMemo, useState } from 'react';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';

const UserDataPieChart = ({ title, type, platform }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        getData().then();
    }, [platform, type]);

    const getData = async () => {
        try {
            const response = await RefreshCheckApi.get(`/adminStatus/${type}/chart`, {
                params: {
                    platform,
                },
            });

            setData(response.data.chart_data);
        } catch (err) {}
    };

    const chartData = useMemo(() => {
        if (type !== 'age') return data;

        const mergedAgeGroups = data.reduce(
            (acc, item) => {
                if (['10~40세', '41~45세', '46~50세'].includes(item.name)) {
                    acc.younger.value += item.value;
                    return acc;
                }

                if (['71~75세', '76~80세'].includes(item.name)) {
                    acc.senior.value += item.value;
                    return acc;
                }

                if (['81~85세', '86~100세'].includes(item.name)) {
                    acc.older.value += item.value;
                    return acc;
                }

                acc.others.push(item);
                return acc;
            },
            {
                younger: { name: '10~50세', value: 0 },
                senior: { name: '71~80세', value: 0 },
                older: { name: '81~100세', value: 0 },
                others: [],
            },
        );

        return [
            ...(mergedAgeGroups.older.value ? [mergedAgeGroups.older] : []),
            ...(mergedAgeGroups.senior.value ? [mergedAgeGroups.senior] : []),
            ...mergedAgeGroups.others,
            ...(mergedAgeGroups.younger.value ? [mergedAgeGroups.younger] : []),
        ];
    }, [data, type]);

    return (
        <div className="chart-area">
            <ChartTitle>{title}</ChartTitle>
            <PieChartComponents datas={chartData} />
        </div>
    );
};

export default UserDataPieChart;
